import { useContext } from 'react';

import { ContainerContext, ContainerContextState } from './ContainerProvider';

export const useContainer = (): ContainerContextState => {
  const context = useContext(ContainerContext);

  return context;
};
